import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { approveTaskRoutine } from 'features/taskManagement/ducks/actions'
import ConfirmModal from 'features/portfolio/components/ConfirmModal'
import { approveConfirmOptions } from 'features/taskManagement/approveConfirm'

export const canApproveFromPill = task =>
  task?.status === 'awaiting_approval' && !!task?.permissions?.canApprove

const stop = e => e.stopPropagation()

export const useApproveFromPill = () => {
  const dispatch = useDispatch()
  const [pending, setPending] = useState(null)

  const approve = useCallback((task, e) => {
    e?.stopPropagation?.()
    if (!canApproveFromPill(task)) return
    setPending(task)
  }, [])

  const close = useCallback(() => setPending(null), [])

  const confirmNode = pending ? (
    <span onClick={stop} onMouseDown={stop} onPointerDown={stop} onKeyDown={stop}>
      <ConfirmModal
        {...approveConfirmOptions(pending)}
        onConfirm={() => {
          dispatch(approveTaskRoutine(pending.id))
          setPending(null)
        }}
        onClose={close}
      />
    </span>
  ) : null

  return [approve, confirmNode]
}
